export default function() {
  return [
    {
      title: "Dashboard",
      to: "/blog-overview",
      htmlBefore: '<i class="material-icons">edit</i>',
      htmlAfter: ""
    },
    {
      title         : "Class",
      to            : "/class",
      htmlBefore    : '<i class="material-icons">group</i>',
    },
    {
      title         : "Subject",
      to            : "/subject",
      htmlBefore    : '<i class="material-icons">library_books</i>',
    },
     {
      title         : "Faculty",
      to            : "/faculty",
      htmlBefore    : '<i class="material-icons">assignment_ind</i>',
    },
    {
      title         : "Exam",
      to            : "/exam",
      htmlBefore    : '<i class="material-icons">assignment</i>',
    },
    {
      title         : "Student",
      to            : "/student",
      htmlBefore    : '<i class="material-icons">perm_identity</i>',
    },
    {
      title         : "HomeWork",
      to            : "/homework",
      htmlBefore    : '<i class="material-icons">book</i>',
    },
    {
      title         : "TimeTable",
      to            : "/timetable",
      htmlBefore    : '<i class="material-icons">calendar_today</i>',
    },
    {
      title         : "Attendance",
      to            : "/attendance",
      htmlBefore    : '<i class="material-icons">pan_tool</i>',
    },

    {
      title         : "Results",
      to            : "/result",
      htmlBefore    : '<i class="material-icons">trending_up</i>',
    },
    {
      title         : "Fees",
      to            : "/fees",
      htmlBefore    : '<i class="material-icons">receipt</i>',
    },
    {
      title         : "Messaging",
      to            : "/message",
      htmlBefore    : '<i class="material-icons">chat</i>',
    },


    {
      title: "News Feed",
      htmlBefore: '<i class="material-icons">vertical_split</i>',
      to: "/blog-posts",
    },
    {
      title: "Add New Post",
      htmlBefore: '<i class="material-icons">note_add</i>',
      to: "/add-new-post",
    },
  


  ];
}

  /*
    {
      title: "Forms & Components",
      htmlBefore: '<i class="material-icons">view_module</i>',
      to: "/components-overview",
    },
    {
      title: "Tables",
      htmlBefore: '<i class="material-icons">table_chart</i>',
      to: "/tables",
    },
    {
      title: "User Profile",
      htmlBefore: '<i class="material-icons">person</i>',
      to: "/user-profile-lite",
    },
    {
      title: "Errors",
      htmlBefore: '<i class="material-icons">error</i>',
      to: "/errors",
    }

  */